import { render, staticRenderFns } from "./FluxCD.vue?vue&type=template&id=6b3a6d66&scoped=true"
import script from "./FluxCD.vue?vue&type=script&lang=js"
export * from "./FluxCD.vue?vue&type=script&lang=js"
import style0 from "./FluxCD.vue?vue&type=style&index=0&id=6b3a6d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a6d66",
  null
  
)

export default component.exports